import { get, post, put, deleted } from '..';
import routes from './routes';

const StoreServices = {
  createStore: async (obj) => {
    const data = await post(routes.createStore, obj);
    return data;
  },
  getStores: async (params) => {
    const data = await get(routes.getStores, params);
    return data;
  },
  getStoreById: async (id) => {
    const data = await get(routes.getStoreById + id);
    return data;
  },
  updateStore: async (id, obj) => {
    const data = await put(routes.updateStore + id, obj);
    return data;
  },
  deleteStore: async (id) => {
    const data = await deleted(routes.deleteStore + id);
    return data;
  },
}

export default StoreServices